import { Box, Typography, useTheme } from '@mui/material';
import { SingleFixtureNextLast } from '../FixturesNextLast';
import InformationPorcentajes from '@/components/shared/custom/information-porcentajes';
import FixtureScore from '@/components/shared/fixture-score';
import TierIcon from '@/components/equipos/tier-icon';
import VerifiedIcon from '@/components/home/icons/verified-icon';
import FailIcon from '@/components/home/icons/fail-icon';
import CustomSectionWrapper from '@/DesignSystem/wrappers/CustomSectionWrapper';

const ProximoPartido = ({ player }) => {
    const theme = useTheme();
    const nextFixture = player?.next?.[0];
    const titularidad = player?.pp?.t;
    const seguridad = player?.pp?.s;
    const puntuacionEsperada60m = player?.pp?.pe;
    const puntuacionEsperadaMenos60m = player?.pp?.pes;
    const tier = player?.pp?.tier;
    const isTitular = player?.pp?.ist;

    return (
        <CustomSectionWrapper title={'Próximo partido'}>
            <Box display={'flex'} width={'100%'} py={1}>
                <Box
                    display={'flex'}
                    flexDirection={'column'}
                    width={'20%'}
                    alignItems={'center'}
                    borderRight={`1px solid ${theme.palette.border.main}`}
                >
                    <Typography
                        height={'20px'}
                        fontSize={14}
                        textOverflow={'ellipsis'}
                        overflow={'hidden'}
                        whiteSpace={'nowrap'}
                        maxWidth={'100%'}
                        fontWeight={500}
                    >
                        Rival
                    </Typography>
                    <Box
                        display={'flex'}
                        justifyContent={'center'}
                        alignItems={'center'}
                        width={'100%'}
                        height={'calc(100% - 20px)'}
                    >
                        <SingleFixtureNextLast fixture={nextFixture} width={'100%'} isLastInList={true} />
                    </Box>
                </Box>

                <Box
                    width={'80%'}
                    display={'flex'}
                    justifyContent={'center'}
                    alignItems={'flex-start'}
                    flexDirection={'column'}
                    ml={1}
                >
                    <Box display={'flex'} justifyContent={'center'} alignItems={'center'} gap={0.5}>
                        <Typography fontSize={12}>Titular: </Typography>
                        {isTitular ? <VerifiedIcon width={15} /> : <FailIcon width={15} />}
                        <InformationPorcentajes
                            text={titularidad}
                            styles={{ width: '100%', minWidth: '40px', width: '40px' }}
                            fontSize="12px"
                        />
                    </Box>
                    <Box display={'flex'} alignItems={'center'} gap={0.5}>
                        <Typography fontSize={12}>Seguridad: </Typography>
                        <InformationPorcentajes
                            text={seguridad}
                            styles={{ width: '100%', minWidth: '40px', width: '40px' }}
                            fontSize="12px"
                        />
                    </Box>
                    <Box display={'flex'} justifyContent={'center'} alignItems={'center'} gap={0.5}>
                        <Typography fontSize={12}>Puntuación esperada titular: </Typography>
                        <FixtureScore
                            score={puntuacionEsperada60m}
                            isAvailable={true}
                            width={15}
                            height={15}
                        />
                    </Box>
                    <Box display={'flex'} justifyContent={'center'} alignItems={'center'} gap={0.5}>
                        <Typography fontSize={12}>Puntuación esperada suplente: </Typography>
                        <FixtureScore
                            score={puntuacionEsperadaMenos60m}
                            isAvailable={true}
                            width={15}
                            height={15}
                        />
                    </Box>
                </Box>
                <TierIcon
                    tier={tier}
                    styles={{ borderRadius: '4px', height: '20px', width: '40px', margin: 'auto' }}
                    fontSize={12}
                />
            </Box>
        </CustomSectionWrapper>
    );
};

export default ProximoPartido;
